import { ReactComponentType } from 'strapi/component/types';
import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import { collectButtonComponentParams } from '../landingButton';
import { collectMediaElementParams } from '../shared/mediaElement';

import { MediaSpotlight } from './MediaSpotlight';
import {
  ImageSectionSingleStrapiComponent,
  MediaSpotlightProps,
} from './types';

export const collectImageSectionSingleComponentParams = (
  data: ImageSectionSingleStrapiComponent,
  page: PageTypes
): MediaSpotlightProps | undefined => {
  const media = collectMediaElementParams(data.media);

  if (!media) {
    return undefined;
  }

  return {
    title: data.title,
    description: data.description,
    button: collectButtonComponentParams(page, data.button)!,
    media,
  };
};

export const collectImageSectionSingleParams = (
  _: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof MediaSpotlight> | undefined => {
  if (!('imageSectionSingle' in page) || !page.imageSectionSingle) {
    return undefined;
  }

  const props = collectImageSectionSingleComponentParams(
    page.imageSectionSingle,
    page
  );

  if (!props) {
    return undefined;
  }

  return {
    component: ReactComponentType.MediaSpotlight,
    props: props,
  };
};
